export default {
    row1: [
        {
            column: "column1",
            columnWidth: "60%",
            rows: {
                row1: [
                    {
                        name: "carrierAir",
                        checkboxLabel: "Air",
                        component: "checkboxbox",
                        sx: {
                            height: "60px",
                            alignItems: "end"
                        }
                    },
                    {
                        name: "airlinecode",
                        label: "Air Line",
                        component: "text-field",

                    },
                    {
                        name: "airlinecodeMaster",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getAirline",
                        autofillTargets: {
                            airlinecode: "code",
                        },

                    }
                ],

                row2: [
                    {
                        name: "carrierSea",
                        checkboxLabel: "Sea",
                        component: "checkboxbox",
                        sx: {
                            height: "60px",
                            alignItems: "end"
                        }
                    },
                    {
                        name: "shippingLineMaster",
                        label: "Shipping Line",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getShipingLine"

                    },
                ],
                row3: [
                    {
                        name: "carrierRoad",
                        checkboxLabel: "Road",
                        component: "checkboxbox",
                        sx: {
                            height: "60px",
                            alignItems: "end"
                        }
                    },

                ],
                row4: [
                    {
                        name: "carrierRail",
                        checkboxLabel: "Rail",
                        component: "checkboxbox",
                        sx: {
                            height: "60px",
                            alignItems: "end"
                        }
                    }

                ],
            }
        }
    ]
}